import { useMutation } from 'query';
import { useUpdateCommentLike } from '../../hooks';
import { unlikeObject } from '../../services';
import type { UseCommentLikeActionType } from './useCommentLikeObjectMutation';

export const useCommentUnlikeObjectMutation = () => {
  const updateComments = useUpdateCommentLike({ action: 'unlike' });

  return useMutation<unknown, UseCommentLikeActionType>({
    mutationFn: async ({ id }) => unlikeObject({ routeParams: { id } }),
    onSuccess(_, params) {
      updateComments(params);
    },
  });
};
